module.exports = __webpack_public_path__ + "img/header.084f7402.png";